<template>
  <div>
    <div class="tw-items-center tw-px-4 tw-pb-8 tw-bg-white tw-shadow-md tw-pt-3.5">
      <p class="tw-text-base tw-leading-14px tw-font-medium tw-pb-4">Symptom Record</p>
      <div class="tw-mb-6">
        <label class="tw-font-normal tw-text-sm tw-leading-14px tw-py-0 tw-block">
          If you know the player (or ask parents / friends) is the player acting differently
          compared to their usual self?
        </label>
        <summary-record-player-self
          :stepProp="playerSelfState"
          @step="getPlayerSelfState($event)"
        />
      </div>
      <p class="tw-black tw-font-normal tw-text-sm tw-leading-18px">
        Complete the following based on how the player feels now. A parent should help answer these
        questions if the player is 12 years old or younger.
      </p>
      <p class="tw-font-medium tw-text-black tw-text-left tw-text-sm tw-leading-18px tw-pb-6">
        Rank the severity of the specific symptom from 0-6, 0 being no pain, 1-2 mild, 3-4 moderate,
        and 5-6 being severe.
      </p>

      <div v-for="question in questions" :key="question.symptom" class="tw-h-60px tw-mb-6">
        <label class="tw-font-normal tw-text-sm tw-leading-14px tw-py-0 tw-block">{{
          question.label
        }}</label>
        <SummaryRecordSlidder :stepProp="question.step" @step="getStepValue($event, question)" />
      </div>
    </div>
    <div class="tw-flex tw-justify-center tw-mt-8">
      <button
        v-if="playerSelfState"
        class="tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 sm:tw-max-w-xs hover:tw-bg-green-300 hover:tw-text-black"
        type="success"
        size="medium"
        @click="next"
      >
        Continue
      </button>

      <button
        v-else
        class="tw-justify-center tw-w-full tw-h-10 tw-rounded-lg tw-capitalize tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center tw-text-white tw-bg-green-700 sm:tw-max-w-xs hover:tw-bg-green-300 hover:tw-text-black"
        size="medium"
        @click="saveLater"
      >
        Save Draft
      </button>
    </div>
  </div>
</template>

<script>
import SummaryRecordPlayerSelf from "./SummaryRecordPlayerSelf.vue";
import SummaryRecordSlidder from "./SummaryRecordSlidder.vue";
export default {
  components: { SummaryRecordSlidder, SummaryRecordPlayerSelf },
  props: ["injury"],
  data() {
    return {
      stepName: "",

      playerSelfState: undefined,
      symptomRecord: {
        playerSelfState: undefined,
        headache: { step: 0, stepName: "None" },
        pressureInHead: { step: 0, stepName: "None" },
        neckPain: { step: 0, stepName: "None" },
        nauseaOrVomit: { step: 0, stepName: "None" },
        dizzy: { step: 0, stepName: "None" },
        blurVision: { step: 0, stepName: "None" },
        balanceProblem: { step: 0, stepName: "None" },
        lightSensitivity: { step: 0, stepName: "None" },
        noiseSensitivity: { step: 0, stepName: "None" },
        slowedDown: { step: 0, stepName: "None" },
        inAFog: { step: 0, stepName: "None" },
        notFeelRight: { step: 0, stepName: "None" },
        difficultyInConcentrating: { step: 0, stepName: "None" },
        difficultyRemembering: { step: 0, stepName: "None" },
        fatigued: { step: 0, stepName: "None" },
        confused: { step: 0, stepName: "None" },
        drowsy: { step: 0, stepName: "None" },
        emotional: { step: 0, stepName: "None" },
        irritable: { step: 0, stepName: "None" },
        sad: { step: 0, stepName: "None" },
        nervousOrAnxious: { step: 0, stepName: "None" },
      },
      questions: [
        {
          symptom: "headache",
          label: "Does the player have a headache?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "pressureInHead",
          label: "Does the player feel 'pressure in the head'?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "neckPain",
          label: "Does the player have neck pain?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "nauseaOrVomit",
          label: "Is there nausea or vomiting?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "dizzy",
          label: "Does the player feel dizzy?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "blurVision",
          label: "Does the player have blurred vision?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "balanceProblem",
          label: "Does the player have balance problems?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "lightSensitivity",
          label: "Is the player sensitive to light?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "noiseSensitivity",
          label: "Is the player sensitive to noise?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "slowedDown",
          label: "Does the player feel 'slowed down'?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "inAFog",
          label: "Does the player feel like they are 'in a fog'?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "notFeelRight",
          label: "Does the player just 'not feel right'?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "difficultyInConcentrating",
          label: "Does the player have difficulty concentrating?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "difficultyRemembering",
          label: "Does the player have difficulty remembering?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "fatigued",
          label: "Does the player feel fatigued or has low energy?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "confused",
          label: "Is the player confused?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "drowsy",
          label: "Does the player feel drowsy?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "emotional",
          label: "Is the player more emotional that normal?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "irritable",
          label: "Is the player irritable?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "sad",
          label: "Does the player feel sad?",
          stepName: "None",
          step: 0,
        },
        {
          symptom: "nervousOrAnxious",
          label: "Is the player nervous or anxious?",
          stepName: "None",
          step: 0,
        },
      ],
      submitted: false,
      treatmentStep: false,
      noStep: {
        symptom: "",
        label: "",
        stepName: "None",
        step: 0,
      },
    };
  },
  beforeMount() {
    const symptomsRec = this.injury?.symptomRecord;
    if (symptomsRec) {
      this.questions.forEach((ques) => {
        ques.symptom === "headache" ? Object.assign(ques, symptomsRec.headache) : this.noStep;
        ques.symptom === "pressureInHead"
          ? Object.assign(ques, symptomsRec.pressureInHead)
          : this.noStep;
        ques.symptom === "neckPain" ? Object.assign(ques, symptomsRec.neckPain) : this.noStep;
        ques.symptom === "nauseaOrVomit"
          ? Object.assign(ques, symptomsRec.nauseaOrVomit)
          : this.noStep;
        ques.symptom === "dizzy" ? Object.assign(ques, symptomsRec.dizzy) : this.noStep;
        ques.symptom === "blurVision" ? Object.assign(ques, symptomsRec.blurVision) : this.noStep;
        ques.symptom === "balanceProblem"
          ? Object.assign(ques, symptomsRec.balanceProblem)
          : this.noStep;
        ques.symptom === "lightSensitivity"
          ? Object.assign(ques, symptomsRec.lightSensitivity)
          : this.noStep;
        ques.symptom === "noiseSensitivity"
          ? Object.assign(ques, symptomsRec.noiseSensitivity)
          : this.noStep;
        ques.symptom === "slowedDown" ? Object.assign(ques, symptomsRec.slowedDown) : this.noStep;
        ques.symptom === "inAFog" ? Object.assign(ques, symptomsRec.inAFog) : this.noStep;
        ques.symptom === "notFeelRight"
          ? Object.assign(ques, symptomsRec.notFeelRight)
          : this.noStep;
        ques.symptom === "difficultyInConcentrating"
          ? Object.assign(ques, symptomsRec.difficultyInConcentrating)
          : this.noStep;
        ques.symptom === "difficultyRemembering"
          ? Object.assign(ques, symptomsRec.difficultyRemembering)
          : this.noStep;
        ques.symptom === "fatigued" ? Object.assign(ques, symptomsRec.fatigued) : this.noStep;
        ques.symptom === "confused" ? Object.assign(ques, symptomsRec.confused) : this.noStep;
        ques.symptom === "drowsy" ? Object.assign(ques, symptomsRec.drowsy) : this.noStep;
        ques.symptom === "emotional" ? Object.assign(ques, symptomsRec.emotional) : this.noStep;
        ques.symptom === "irritable" ? Object.assign(ques, symptomsRec.irritable) : this.noStep;
        ques.symptom === "sad" ? Object.assign(ques, symptomsRec.sad) : this.noStep;
        ques.symptom === "nervousOrAnxious"
          ? Object.assign(ques, symptomsRec.nervousOrAnxious)
          : this.noStep;
      });
      this.playerSelfState = symptomsRec.playerSelfState;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    next() {
      this.submitted = true;
      this.saveSymptomRecord();

      this.treatmentStep = true;
      this.$emit("treatment", this.treatmentStep, this.symptomRecord);
    },
    getStepValue(stepValue, question) {
      const identifiedQuestion = this.questions.find((ques) => ques.symptom === question.symptom);
      identifiedQuestion.stepName = stepValue.name;
      identifiedQuestion.step = stepValue.step;
    },
    getPlayerSelfState(stepValue, question) {
      switch (stepValue) {
        case 0:
          this.playerSelfState = "No different";
          break;
        case 1:
          this.playerSelfState = "Very different";
          break;
        case 2:
          this.playerSelfState = "Unsure";
          break;
        case 3:
          this.playerSelfState = "Not applicable";
          break;
        default:
          this.playerSelfState = "No different";
          break;
      }
    },
    async saveLater() {
      this.saveSymptomRecord();

      this.injury.symptomRecord = Object.assign({}, this.symptomRecord);

      if (this.injury._id) {
        await this.$http
          .put(`/nrl/api/v1/admin/injury-cases/${this.injury._id}`, this.injury)
          .then((res) => {
            this.$router.push("/injury-cases");
            this.$customSuccess();
          })
          .catch(() => {
            this.$store.commit("root/loading", false);
            this.$customError();
          });
      } else {
        await this.$http
          .post("/nrl/api/v1/admin/injury-cases", this.injury)
          .then((res) => {
            this.injury._id = res.data.data;
            this.$router.push({
              name: "injury-cases",
            });
            this.$customSuccess();
          })
          .catch((error) => {
            this.$store.commit("root/loading", false);

            if (_.get(error, "response.data.message") === "'memberId' is required") {
              this.$customError("Please select a member");
            } else {
              this.$customError();
            }
          });
      }
    },
    saveSymptomRecord() {
      //Headache
      let headache = this.questions.find((ques) => ques.symptom === "headache");

      this.symptomRecord.headache.step = headache.step;
      this.symptomRecord.headache.stepName = headache.stepName;

      //PressureInHead
      let pressureInHead = this.questions.find((ques) => ques.symptom === "pressureInHead");

      this.symptomRecord.pressureInHead.step = pressureInHead.step;
      this.symptomRecord.pressureInHead.stepName = pressureInHead.stepName;

      //NeckPain
      let neckPain = this.questions.find((ques) => ques.symptom === "neckPain");

      this.symptomRecord.neckPain.step = neckPain.step;
      this.symptomRecord.neckPain.stepName = neckPain.stepName;

      //NauseaOrVomit
      let nauseaOrVomit = this.questions.find((ques) => ques.symptom === "nauseaOrVomit");

      this.symptomRecord.nauseaOrVomit.step = nauseaOrVomit.step;
      this.symptomRecord.nauseaOrVomit.stepName = nauseaOrVomit.stepName;

      //Dizzy
      let dizzy = this.questions.find((ques) => ques.symptom === "dizzy");

      this.symptomRecord.dizzy.step = dizzy.step;
      this.symptomRecord.dizzy.stepName = dizzy.stepName;

      //BlurVision
      let blurVision = this.questions.find((ques) => ques.symptom === "blurVision");

      this.symptomRecord.blurVision.step = blurVision.step;
      this.symptomRecord.blurVision.stepName = blurVision.stepName;

      //BalanceProblem
      let balanceProblem = this.questions.find((ques) => ques.symptom === "balanceProblem");

      this.symptomRecord.balanceProblem.step = balanceProblem.step;
      this.symptomRecord.balanceProblem.stepName = balanceProblem.stepName;

      //LightSensitivity
      let lightSensitivity = this.questions.find((ques) => ques.symptom === "lightSensitivity");

      this.symptomRecord.lightSensitivity.step = lightSensitivity.step;
      this.symptomRecord.lightSensitivity.stepName = lightSensitivity.stepName;

      //NoiseSensitivity
      let noiseSensitivity = this.questions.find((ques) => ques.symptom === "noiseSensitivity");

      this.symptomRecord.noiseSensitivity.step = noiseSensitivity.step;
      this.symptomRecord.noiseSensitivity.stepName = noiseSensitivity.stepName;

      //SlowedDown
      let slowedDown = this.questions.find((ques) => ques.symptom === "slowedDown");

      this.symptomRecord.slowedDown.step = slowedDown.step;
      this.symptomRecord.slowedDown.stepName = slowedDown.stepName;

      //InAFog
      let inAFog = this.questions.find((ques) => ques.symptom === "inAFog");

      this.symptomRecord.inAFog.step = inAFog.step;
      this.symptomRecord.inAFog.stepName = inAFog.stepName;

      //NotFeelRight
      let notFeelRight = this.questions.find((ques) => ques.symptom === "notFeelRight");

      this.symptomRecord.notFeelRight.step = notFeelRight.step;
      this.symptomRecord.notFeelRight.stepName = notFeelRight.stepName;

      //DifficultyInConcentrating
      let difficultyInConcentrating = this.questions.find(
        (ques) => ques.symptom === "difficultyInConcentrating"
      );

      this.symptomRecord.difficultyInConcentrating.step = difficultyInConcentrating.step;
      this.symptomRecord.difficultyInConcentrating.stepName = difficultyInConcentrating.stepName;

      //DifficultyRemembering
      let difficultyRemembering = this.questions.find(
        (ques) => ques.symptom === "difficultyRemembering"
      );

      this.symptomRecord.difficultyRemembering.step = difficultyRemembering.step;
      this.symptomRecord.difficultyRemembering.stepName = difficultyRemembering.stepName;

      //Fatigued
      let fatigued = this.questions.find((ques) => ques.symptom === "fatigued");

      this.symptomRecord.fatigued.step = fatigued.step;
      this.symptomRecord.fatigued.stepName = fatigued.stepName;

      //Confused
      let confused = this.questions.find((ques) => ques.symptom === "confused");

      this.symptomRecord.confused.step = confused.step;
      this.symptomRecord.confused.stepName = confused.stepName;

      //Drowsy
      let drowsy = this.questions.find((ques) => ques.symptom === "drowsy");

      this.symptomRecord.drowsy.step = drowsy.step;
      this.symptomRecord.drowsy.stepName = drowsy.stepName;

      //Emotional
      let emotional = this.questions.find((ques) => ques.symptom === "emotional");

      this.symptomRecord.emotional.step = emotional.step;
      this.symptomRecord.emotional.stepName = emotional.stepName;

      //Irritable
      let irritable = this.questions.find((ques) => ques.symptom === "irritable");

      this.symptomRecord.irritable.step = irritable.step;
      this.symptomRecord.irritable.stepName = irritable.stepName;

      //Sad
      let sad = this.questions.find((ques) => ques.symptom === "sad");

      this.symptomRecord.sad.step = sad.step;
      this.symptomRecord.sad.stepName = sad.stepName;

      //NervousOrAnxious
      let nervousOrAnxious = this.questions.find((ques) => ques.symptom === "nervousOrAnxious");

      this.symptomRecord.nervousOrAnxious.step = nervousOrAnxious.step;
      this.symptomRecord.nervousOrAnxious.stepName = nervousOrAnxious.stepName;

      //Player Self Usuaal State
      this.symptomRecord.playerSelfState = this.playerSelfState;
    },
  },
};
</script>

<style scoped>
select {
  background-position-y: "-1px";
  font-weight: 400;
}
select:not(:first-child) {
  font-weight: 500;
}
</style>
